import { render, staticRenderFns } from "./formDeclare.vue?vue&type=template&id=01b70d51&scoped=true&"
import script from "./formDeclare.vue?vue&type=script&lang=js&"
export * from "./formDeclare.vue?vue&type=script&lang=js&"
import style0 from "./formDeclare.vue?vue&type=style&index=0&id=01b70d51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b70d51",
  null
  
)

export default component.exports